import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable, pipe } from 'rxjs';
import { tap } from 'rxjs/operators';
import { LoaderService } from './loader.service';
// @Injectable({
//   providedIn: 'root'
// })
@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loaderService: LoaderService) { }

  apisDash = ['dashstatusroteiro',
  'tempotrabalhadodash',
  'roteironodiadash',
  'fotosnodiadash',
  'roteirodiariodash',
  'listartempodeslocamento',
  'analiseexecucaodash',
  'abastecimentomarcasdash',
  'promotoresonlinedash',
  'rupturaspordiadash',
  'notificacao',
  'segmentoproduto',
  'timeline/localizacao',
  'timeline/dados',
  'timeline/listar',
  'timeline/roteiro',
  'checarsessao',

  // Auto-cadastro publico do promotor.
  // O download do contrato ja tem spinner proprio dentro do modal - sem isso aparecem dois.
  'cadastropromotor/contrato/arquivo',
  // Consultado a cada abertura da tela de login: o loader global piscaria em todo acesso.
  'cadastropromotor/habilitado',

  // Roteiro inteligente: revalida a cada clique; tem spinner próprio sobre o mapa.
  // Gerar e salvar rascunho continuam com o loader global.
  'roteirointeligente/validar',
  'roteirointeligente/lojas',
  'roteirointeligente/familias',
  'roteirointeligente/produtos',
  'roteirointeligente/promotores',
  'roteirointeligente/tarefaspersonalizadas',
  'roteirointeligente/subcategorias',
  'roteirointeligente/roteirosexistentes',

  // Vídeo de treinamento: o envio tem barra de progresso própria na tela.
  'videotreinamento/upload'];

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let reqUrl = req.url.toLowerCase();
    let contem = function(elem) {
      return reqUrl.includes(elem);
    };
    if (!this.apisDash.some(contem)) {
      this.showLoader();
    }
    return next.handle(req).pipe(tap((event: HttpEvent<any>) => {
      if (event instanceof HttpResponse) {
        if (!this.apisDash.some(contem)) {
          this.onEnd();
        }
      }
    },
      (err: any) => {
        if (!this.apisDash.some(contem)) {
          this.onEnd();
        }
    }));
  }
  private onEnd(): void {
    this.hideLoader();
  }
  private showLoader(): void {
    this.loaderService.show();
  }
  private hideLoader(): void {
    this.loaderService.hide();
  }
}
